import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Brand } from '../../components/layout/AuthLayout';
import { GlobeIcon } from '../../components/common/Icons';
import { REGIONS } from '../../utils/plans';

const REGION_ITEMS = [REGIONS.BR, REGIONS.US, REGIONS.EU, REGIONS.OTHER];

const LocationPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const pendingRegistration = sessionStorage.getItem('clarityPendingRegistration');

  const selectRegion = (region) => {
    localStorage.setItem('clarityRegion', JSON.stringify(region));
    navigate('/plans');
  };

  React.useEffect(() => {
    if (!pendingRegistration) navigate('/register', { replace: true });
  }, [navigate, pendingRegistration]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10 text-slate-900">
      <div className="w-full max-w-xl">
        <Brand className="mb-8 justify-center" />

        <section className="rounded-lg border border-slate-200 bg-white p-8 text-center shadow-soft">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full">
            <img src="logos/icone-96.png" alt="Clarity Files" />
          </div>
          <h1 className="mt-5 text-2xl font-bold text-slate-900">{t('location.title')}</h1>
          <p className="mx-auto mt-3 max-w-sm text-slate-600">{t('location.subtitle')}</p>

          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            {REGION_ITEMS.map((region) => (
              <button
                key={region.id}
                className="flex min-h-36 flex-col items-center justify-center rounded-lg border border-slate-100 bg-white p-5 shadow-soft transition hover:-translate-y-0.5 hover:border-sky-200 hover:shadow-lg"
                type="button"
                onClick={() => selectRegion(region)}
              >
                <span className="text-4xl">{region.flag}</span>
                <span className="mt-4 font-bold text-slate-900">{t(`location.${region.id}`)}</span>
                <span className="mt-2 text-sm text-slate-600">{region.currency}</span>
              </button>
            ))}
          </div>

          <p className="mt-8 flex items-center justify-center gap-2 text-sm text-slate-600">
            <GlobeIcon className="h-4 w-4" />
            {t('location.currencyNote')}
          </p>
        </section>
      </div>
    </main>
  );
};

export default LocationPage;
